"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmentModalView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-console */
const React = __importStar(require("react"));
const developmentMobileCommunicator_1 = require("../developmentMobileCommunicator");
const sections = [
    {
        label: 'Mobile Communicator',
        component: (0, jsx_runtime_1.jsx)(developmentMobileCommunicator_1.DevelopmenMobileCommunicatorView, {}),
    },
];
const SelectionView = ({ onSelect }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: { display: 'flex', flexDirection: 'row', padding: '1rem 0' }, children: (0, jsx_runtime_1.jsx)("h1", { style: { fontSize: '1.5rem', fontWeight: 'bold' }, children: "Developer View" }) }), (0, jsx_runtime_1.jsx)("div", { style: { padding: '2rem 0 1rem' }, children: (0, jsx_runtime_1.jsx)("ul", { style: { display: 'grid', gap: '2rem', gridTemplateColumns: 'auto auto auto' }, children: sections.map(section => ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", { style: {
                            padding: '0.4rem',
                            borderRadius: '10px',
                            border: '1px solid black',
                            cursor: 'pointer',
                        }, onClick: () => onSelect(section), children: section.label }) }, section.label))) }) })] }));
const AppView = ({ onBack, app }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', flexDirection: 'row', padding: '1rem 0' }, children: [(0, jsx_runtime_1.jsx)("span", { style: {
                        cursor: 'pointer',
                        border: 'solid black',
                        borderWidth: '0 6px 6px 0',
                        display: 'inline-block',
                        padding: '0.8rem',
                        transform: 'rotate(135deg)',
                        WebkitTransform: 'rotate(135deg)',
                    }, onClick: onBack }), (0, jsx_runtime_1.jsx)("h1", { style: { fontSize: '1.5rem', fontWeight: 'bold' }, children: app.label })] }), (0, jsx_runtime_1.jsx)("div", { style: { padding: '2rem 0 1rem' }, children: app.component })] }));
const DevelopmentModalView = () => {
    const [app, setApp] = React.useState(null);
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            zIndex: 10,
            position: 'fixed',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            background: 'rgba(0, 0, 0, 0.5)',
        }, children: (0, jsx_runtime_1.jsx)("section", { style: {
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                background: 'white',
                height: 'auto',
                width: 'auto',
                borderRadius: '10px',
                padding: '2rem',
            }, children: app ? (0, jsx_runtime_1.jsx)(AppView, { onBack: () => setApp(null), app: app }) : (0, jsx_runtime_1.jsx)(SelectionView, { onSelect: setApp }) }) }));
};
exports.DevelopmentModalView = DevelopmentModalView;
//# sourceMappingURL=developmentModalView.js.map